import React from "react";

import { styled } from "@mui/material";

import { useProgressBarContext } from "../../../../ProgressBarView/context/ProgressBarContext";
import { ProgressBarBreakpoint } from "../../../../ProgressBarView/types";

interface TooltipProps {
  breakpoint: ProgressBarBreakpoint;
}

export const Tooltip = ({ breakpoint }: TooltipProps) => {
  if (!breakpoint.tooltipEnabled) {
    return null;
  }

  return (
    <Anchor className={"ig-dp-tooltip"}>
      <Container className={"ig-dp-tooltip-container"}>
        <Arrow>
          <svg width={27} height={14}>
            <Path d="M13.09 0 0 13.09h26.182L13.09 0Z" />
          </svg>
        </Arrow>
        <Message className={"ig-dp-tooltip-msg"}>
          <span>{breakpoint.label}</span>
        </Message>
      </Container>
    </Anchor>
  );
};

const Anchor = styled("span")({
  position: "absolute",
  justifyContent: "center",
  width: 120,
  fontWeight: "bold",
  display: "flex",
  zIndex: 10,
  transform: "translate(-50%, 10px)",
  left: "50%",
});

const Container = styled("div")(() => {
  const { device } = useProgressBarContext();
  return {
    backgroundColor: device.widget.styles.tooltip.backgroundColor,
    borderRadius: 12,
    color: "black",
    minWidth: 65,
    minHeight: 40,
    position: "relative",
  };
});

const Arrow = styled("span")({
  position: "absolute",
  height: 14,
  left: "50%",
  transform: "translate(-50%, -12px)",
});

const Message = styled("div")({
  color: "black",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  margin: "10px",
  height: "calc(100% - 20px)",
  lineHeight: "normal",
});

const Path = styled("path")(() => {
  const { device } = useProgressBarContext();
  return {
    fill: device.widget.styles.tooltip.backgroundColor,
  };
});
